export default "__VITE_ASSET__3927b348__"